import axios from 'axios';

import getIsCypressOnLocalhost from './getIsCypressOnLocalhost';

/**
 * Get the timezone of the given location given as lat/lng coordinates.
 * Uses Google's timezone API with the default timestamp of now.
 *
 * @param {Number} lat The latitude value of the location.
 * @param {Number} lng The longitude value of the location.
 * @return {Object} Google Time Zone response.
 *   See: https://developers.google.com/maps/documentation/timezone/intro
 */
function getTimezone(
  lat: number,
  lng: number
): Promise<{ timeZoneId: string }> {
  return new Promise((resolve, reject) => {
    if (
      getIsCypressOnLocalhost() &&
      process.env.REACT_APP_SENTRY_DSN !== 'qa'
    ) {
      resolve({ timeZoneId: 'America/New_York' });
    }
    const timestamp = Date.now() / 1000;
    axios
      .get(`https://maps.googleapis.com/maps/api/timezone/json`, {
        params: {
          location: [lat, lng].join(','),
          timestamp,
          key: 'AIzaSyDnNNTb0zkKyCf8FNYUGmFnb4qE_IqseGU',
        },
      })
      .then(
        (resp) => {
          resolve(resp.data);
        },
        (error) => {
          if (error.response) {
            reject(error.response.data.error);
          } else {
            reject(error);
          }
        }
      );
  });
}

export default getTimezone;
